import { SET_DEALER_GSTN_VERIFY, SET_DEALER_PAN_NSDL_VERIFY, UPDATE_KYC_PAYLOAD } from '../actionTypes'


export const kycInitialState = {
    bank_details_ticket_id: 0,
    kyc_id: 0,
    panCard: { dealer_pan_card_number: "", dealer_pan_card_name: "", dealer_pan_card_image: "", is_pan_verified: "", panNSDLVerify:false },
    gstn: { gstn_state: "", gstn_pincode: "",entity_type: "", gstn_number: "",gstn_number_last_three_digit:"" ,gstn_account_name: "", gstn_image:"", is_gstn_verified: "", gstnVerify:false },
    bankDetails: { bank_account_number: "", bank_account_name: "", bank_name: "", ifsc_code: "", cancelled_cheque_number: "", cancelled_cheque_image: "", is_bank_details_verified: "" },
    authorizedSignatory: { signatory_relationship: "", supporting_doc: "", signatory_aadhar_number: "", signatory_aadhar_name: "", signatory_aadhar_image: "", signatory_pan_number: "", signatory_pan_name: "", signatory_pan_image: "", is_signatory_aadhar_verified: "", is_signatory_pan_verified: "" },
    tan: {tan_card_number: "", tan_card_image: ""},
}

export default (state = kycInitialState, action) => {
    switch (action.type) {

        case SET_DEALER_PAN_NSDL_VERIFY:
            return {
                ...state,
                panCard: {
                ...state.panCard,
                panNSDLVerify: action.payload,
                },
            };

            case SET_DEALER_GSTN_VERIFY:
                return {
                    ...state,
                    gstn: {
                    ...state.gstn,
                    gstnVerify: action.payload,
                    },
                };
      
        case UPDATE_KYC_PAYLOAD:
            return { ...state, ...action.payload.kyc };


        default: return { ...state };
    }

}